export default {
  title: 'APP VERSION SETTINGS',
  items: {
    ForceUpdateProviderToVersion: {
      label: 'iOS - Force Update PA to Version',
      type: 'string',
      unit: 'version'
    },
    ForceUpdateConsumerToVersion: {
      label: 'iOS - Force Update CA to Version',
      type: 'string',
      unit: 'version'
    },
    ForceUpdateAndroidProviderToVersion: {
      label: 'Android - Force Update PA to Version',
      type: 'string',
      unit: 'version'
    },
    ForceUpdateAndroidConsumerToVersion: {
      label: 'Android - Force Update CA to Version',
      type: 'string',
      unit: 'version'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/version-settings.js